import React from 'react';
import { alpha, useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { SIEMPRE_MAS_MUSICA_LOGO_SRC } from '../brandAssets';

const SHOW_LOGO = SIEMPRE_MAS_MUSICA_LOGO_SRC;

const Values = () => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  const values = [
    {
      title: 'Promoción musical',
      subtitle: 'Difusión de talentos nacionales e internacionales con conversación de calidad y comunidad activa.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
        </svg>
      ),
    },
    {
      title: 'Arlene Flores',
      subtitle: 'Host con credibilidad en la escena: entrevistas, tendencias y cobertura de eventos musicales.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      ),
    },
    {
      title: 'Impacto multiplataforma',
      subtitle: 'Vivo, On-Demand, TNO Digest y redes. Tu mensaje prolonga el alcance del programa.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
        </svg>
      ),
    },
    {
      title: 'Marcas de entretenimiento',
      subtitle: 'Ideal para audio, bebidas, moda urbana, festivales, streaming y lifestyle cultural.',
      icon: (
        <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography sx={{ textTransform: 'uppercase', fontWeight: 'medium' }} gutterBottom color={'primary'} align={'center'}>
          Ventajas Competitivas
        </Typography>
        <Box component={Typography} sx={{ fontWeight: 700 }} variant={'h3'} gutterBottom align={'center'} color={'primary'}>
          ¿Por qué Siempre más Música?
        </Box>
      </Box>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Box
            maxWidth={420}
            width="100%"
            mx="auto"
            sx={{
              minHeight: { xs: 260, sm: 300 },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 3,
              overflow: 'hidden',
              background: `linear-gradient(145deg, ${alpha(primary, 0.08)} 0%, ${alpha(primary, 0.03)} 100%)`,
              border: `1px solid ${alpha(primary, 0.14)}`,
              px: { xs: 3, sm: 4 },
              py: { xs: 4, sm: 5 },
            }}
          >
            <Box
              component="img"
              src={SHOW_LOGO}
              alt="Logo Siempre más Música"
              sx={{
                display: 'block',
                width: '100%',
                maxWidth: { xs: 220, sm: 280 },
                height: 'auto',
                objectFit: 'contain',
                mx: 'auto',
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          {values.map((item, index) => (
            <Box key={index} display="flex" alignItems="flex-start" marginBottom={4} data-aos="fade-up" data-aos-delay={index * 100}>
              <Box
                component="div"
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: '50%',
                  bgcolor: `${theme.palette.primary.light}22`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: theme.palette.primary.main,
                  marginRight: 2,
                  flexShrink: 0,
                }}
              >
                {item.icon}
              </Box>
              <Box>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
                  {item.title}
                </Typography>
                <Typography color="textSecondary">{item.subtitle}</Typography>
              </Box>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Values;
